export class AppComponentConstants {
    static ON_SAME_RELOAD_STRATEGY = "reload";
    static DEFAULT_BASE_HREF = "/";
    static EXTERNAL_LANDING_UNAVAILABLE_WARNING = "The external landing page is unavailable. Continuing with the internal portal flow.";
    static EXTERNAL_LANDING_PENDING_LOGIN_KEY = "externalLandingPendingLogin";
    static START_LOGIN_QUERY_PARAM = "startLogin";
    static FLAG_ENABLED_VALUE = "1";
    static EMPTY_HISTORY_TITLE = "";
    static HASH_CALLBACK_KEYS = ["access_token", "id_token", "token_type", "state", "error"];
    static QUERY_CALLBACK_KEYS = ["code", "state", "session_state", "error"];
}
